var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimilarLeftSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 12,
    viewBox: "0 0 34 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.86663 6.00024L1.59996 5.2669L1.90796 4.9589L6.57196 0.294901L7.6133 1.33623L3.68263 5.2669L33.1333 5.2669L33.1333 6.73357L3.68263 6.73357L7.6133 10.6642L6.57196 11.7056L1.90796 7.0269L1.61463 6.73357L0.86663 6.00024Z",
    fill: "#282825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilarLeftSlider);
export default __webpack_public_path__ + "static/media/similarLeftSlider.5a2d54d1a930078963485df43fef12e4.svg";
export { ForwardRef as ReactComponent };